import AdminLayout from 'components/admin/admin_layout';
import { FrontendErrorFallback } from 'components/shared/frontend_error_fallback';
import AdminAuth from 'containers/admin_auth';
import AdminStateContainer from 'containers/admin_state_container';
import AuthorityStateContainer from 'containers/authority_state_container';
import DealerIndex from 'pages/admin/dealer';
import DealerShow from 'pages/admin/dealer/show';
import LaboratoryIndex from 'pages/admin/laboratory';
import LaboratoryShow from 'pages/admin/laboratory/show';
import LoginPage from 'pages/admin/login';
import React from 'react';
import { RouteObject } from 'react-router-dom';

/**
 * ルート定義
 */
export class AdminRouteHelper {
  static basePath = (path: string): string => `/admin/${path}`;

  public static root = (): string => '/admin';
  // ログイン
  public static login = (): string => AdminRouteHelper.basePath('login');

  // ラボラトリー
  public static laboratoryIndex = (): string => AdminRouteHelper.basePath('laboratories');
  public static laboratoryShow = (id: number | string): string => AdminRouteHelper.basePath(`laboratories/${id}`);

  // ディーラー
  public static dealerIndex = (): string => AdminRouteHelper.basePath('dealers');
  public static dealerShow = (id: number | string): string => AdminRouteHelper.basePath(`dealers/${id}`);
}

export const adminRoutes: RouteObject[] = [
  {
    element: <AdminStateContainer />,
    errorElement: <FrontendErrorFallback />,
    children: [
      { path: AdminRouteHelper.root(), element: <LoginPage /> },
      { path: AdminRouteHelper.login(), element: <LoginPage /> },
      {
        element: <AdminAuth />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              {
                element: <AuthorityStateContainer />,
                children: [
                  {
                    path: AdminRouteHelper.laboratoryIndex(),
                    element: <LaboratoryIndex />,
                  },
                  {
                    path: AdminRouteHelper.laboratoryShow(':id'),
                    element: <LaboratoryShow />,
                  },
                  {
                    path: AdminRouteHelper.dealerIndex(),
                    element: <DealerIndex />,
                  },
                  {
                    path: AdminRouteHelper.dealerShow(':id'),
                    element: <DealerShow />,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
